import { useState } from 'react';

const useInput = (initialValue = '') => {
   const [value, setValue] = useState(initialValue);
   const [isTouched, setIsTouched] = useState(false);
   const [error, setError] = useState('');

   const eventValueChangeHandler = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
      setError('');
      setValue(target.value);
   };

   const valueChangeHandler = (newValue: string) => {
      setError('');
      setValue(newValue);
   }

   const inputBlurHandler = () => {
      setIsTouched(true);
   };

   const reset = () => {
      setIsTouched(false);
      setValue('');
   };

   return {
      value,
      setValue,
      isTouched,
      error,
      eventValueChangeHandler,
      valueChangeHandler,
      inputBlurHandler,
      reset,
      setIsTouched,
      setError,
   };
};

export default useInput;
